<template>
  <div class="content-wrapper">

    <div class="row">
        <div class="col-sm-12 col-md-6">
            <app-breadcrumb
            page-title="Revisión Solicitud de Registro"
            directory="Información"
            :icon="'trello'"
            />
        </div>
        <div class="col-sm-12 col-md-6">
            <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                <a href="/register/users/pending" class="btn btn-primary">Volver</a>
            </div>
        </div>
    </div>

    <div class="card card-with-shadow border-0 mb-primary">
        <div class="card-body">
            <form  ref="form" class="mb-0"
                    data-url="/register/users/organization"
                    enctype="multipart/form-data"
                    :class="{'loading-opacity': preloader}"
                    >


            </form>
        </div>
    </div>

  </div>
</template>

<script>
  import { FormMixin } from "@/core/mixins/form/FormMixin.js";
  import CoreLibrary from "@/core/helpers/CoreLibrary.js";
  import * as actions from "../../apiUrl";

    export default {
        name: "HistoricalAccreditation",
        mixins: [FormMixin,CoreLibrary],
        props: {
            accId: String,
            backUrl: {
                type: String,
                default: '/'
            }
        },
        data() {
            return {
                url: "",
                preloader: true,
                inputs: { }
            }
        },
        created() {
            this.data();
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            afterSuccess(response) {
                this.preloader = true;
                if (response.status == 200) {
                    window.location = '/register/users/pending';
                }
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            data() {
                this.preloader = true;
                console.log(this.accId);
                let url = `${actions.ACCREDITATION_HISTORICAL}/historical/${this.accId}`;
                this.axiosGet(url)
                    .then((response) => {
                        console.log(response);
                        if (response.status == 200) {

                        }
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    })
                    .finally(() => {
                        this.preloader = false;
                    });
            }
        }
    };
</script>
